<template lang="pug">
	div.mt-2
		.d-flex.gap-4
			b-form-group(label=" N° de serie del equipo:" label-for=" N° de serie del equipo:")
				b-form-input(
					v-model="form.serie"
					id="serie"
					maxLength="15"
					placeholder=" N° de serie del equipo:"
					:state="$v.serie.$dirty ? !$v.serie.$error : null" autocomplete="off"
				)
				b-form-invalid-feedback(v-if="!$v.serie.required") El N° de serie es obligatorio.
				b-form-invalid-feedback(v-if="!$v.serie.minLength") El N° de serie debe tener al menos 15 caracteres.
			b-form-group.mb-4(label="RMA" label-for="rma")
				b-form-input(
					id="rma"
					v-model="form.rma"
					maxlength="10"
					placeholder="Ingrese RMA (10 carácteres)"
				)
		b-form-group.mt-2(
			label= "Adjunta una imagen de la etiqueta ubicada en la parte de abajo del equipo"
			label-for="input-document"
		)
		.filePart(
			v-if="!serialImg"
			ref="dragContainer"
			draggable @dragstart=""
			@dragenter="fileDragEnter"
			@dragleave="fileDragLeave"
			@drop="fileDragLeave"
		)
			b-col(id="file")
				.containerInputFile
					input(type="file" id="filePart" ref="file"  @change="handleFileUpload")
					font-awesome-icon.cloud-icon.mb-3(icon="cloud-upload-alt" size="3x")
					label(class="labelDoc") {{ this.serialImg ? this.serialImg.name : 'Arrastra la imagen o haz click aquí' }}
					span.form-btn.flex-row.align-items-center.justify-content-center Subir Archivos
		b-col(v-else cols="12" md="6")
			img(:src="imageUrl" alt="Imagen Etiqueta" style="width: auto; max-width: 400px; max-height: 200px;")
</template>
<script>
import { validationMixin } from 'vuelidate'


export default {
	name: 'StepEquipo',
	props: {
		form: {
			type: Object,
			required: true
		},
		$v: {
			type: Object,
			required: true
		}
	},
	mixins: [validationMixin],
	data() {
		return {
			serialImg: null,
			imageUrl: null,
		}
	},
	methods: {
		handleFileUpload() {
			this.serialImg = this.$refs.file.files[0] // eslint-disable-line
			console.log(this.serialImg)
		},
		fileDragEnter(event) {
			console.log('drag enter', event)
			event.preventDefault()
			this.$refs.dragContainer.classList.add('file-dragover')
		},
		fileDragLeave(event) {
			console.log('drag leave', event)
			event.preventDefault()
			this.$refs.dragContainer.classList.remove('file-dragover')
		},
	},
}
</script>
